import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hmos",
  "use": "icon-hmos-usage",
  "viewBox": "0 0 163 163",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 163 163\" id=\"icon-hmos\">\n    <path d=\"M81.5,159.47a78,78,0,1,1,78-78A78.06,78.06,0,0,1,81.5,159.47Zm0-139.33A61.36,61.36,0,1,0,142.86,81.5,61.43,61.43,0,0,0,81.5,20.14Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol